import Home from "./Home";
import Claiming from "./Claiming";



const routes = [
  
  { path: '/', component: <Home />},
  {path: '/claiming', component: <Claiming />},
]

export default routes;